import { render } from "./ChatBotSendMessageEditorCmp.vue?vue&type=template&id=3c74bf8e"
import script from "./ChatBotSendMessageEditorCmp.vue?vue&type=script&lang=js"
export * from "./ChatBotSendMessageEditorCmp.vue?vue&type=script&lang=js"

import "./ChatBotSendMessageEditorCmp.vue?vue&type=style&index=0&id=3c74bf8e&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__